import React from 'react';

const NavItem = (props) => {

    return (
        <a
            href="/"
            className={props.active}
            onMouseEnter={props.handleMouseEnter.bind(this)}
            onMouseLeave={props.handleMouseLeave.bind(this)}
			onClick={props.handleClick.bind(this)}
        >
            <div className="item">
                <div className="icon">
                    {props.svg}
                </div>
                <span>{props.title}</span>

                <div className="item-clone">
                    <div className="icon">
                        {props.svg}
                    </div>
                    <span>{props.title}</span>
                </div>
            </div>
        </a>
    );

};

export default NavItem;


// WEBPACK FOOTER //
// ./src/js/components/NavItem.js